"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IterationStatementParser = void 0;
const AbstractParseTreeVisitor_1 = require("antlr4ts/tree/AbstractParseTreeVisitor");
const errors_1 = require("./errors");
const expressionParser_1 = require("./expressionParser");
const statementParser_1 = require("./statementParser");
class IterationStatementParser extends AbstractParseTreeVisitor_1.AbstractParseTreeVisitor {
    constructor() {
        super(...arguments);
        this.expressionParser = new expressionParser_1.default();
    }
    bodyWrapper(ctx) {
        const body = ctx._body;
        if (body == undefined) {
            return [this.defaultResult()];
        }
        const statements = new statementParser_1.StatementParser().visit(body);
        if (statements.type == 'BlockStatement') {
            return statements.body;
        }
        else {
            return [statements];
        }
    }
    defaultResult() {
        return {
            type: 'EmptyStatement'
        };
    }
    visitErrorNode(node) {
        throw new errors_1.FatalSyntaxError({
            start: {
                line: node.symbol.line,
                column: node.symbol.charPositionInLine
            },
            end: {
                line: node.symbol.line,
                column: node.symbol.charPositionInLine + 1
            }
        }, `invalid syntax ${node.text}`);
    }
    visitIterationStatement(ctx) {
        const forLoop = ctx.forLoop();
        const doWhileLoop = ctx.doWhileLoop();
        const whileLoop = ctx.whileLoop();
        if (forLoop != undefined) {
            return this.visitForStatement(forLoop);
        }
        else if (doWhileLoop != undefined) {
            return this.visitDoWhileStatement(doWhileLoop);
        }
        else if (whileLoop != undefined) {
            return this.visitWhileStatement(whileLoop);
        }
        return this.defaultResult();
    }
    visitForStatement(ctx) {
        const forCondition = ctx._innerForCondition;
        return {
            type: 'ForStatement',
            init: this.expressionParser.visit(forCondition._initialise),
            test: this.expressionParser.visit(forCondition._test),
            update: this.expressionParser.visit(forCondition._update),
            body: { type: 'BlockStatement', body: this.bodyWrapper(ctx) }
        };
    }
    visitWhileStatement(ctx) {
        return {
            type: 'WhileStatement',
            test: this.expressionParser.visit(ctx._condition),
            body: { type: 'BlockStatement', body: this.bodyWrapper(ctx) }
        };
    }
    visitDoWhileStatement(ctx) {
        return {
            type: 'DoWhileStatement',
            test: this.expressionParser.visit(ctx._condition),
            body: { type: 'BlockStatement', body: this.bodyWrapper(ctx) }
        };
    }
}
exports.IterationStatementParser = IterationStatementParser;
//# sourceMappingURL=iterationStatementParser.js.map